import React from 'react'
import cx from 'classnames'
import styles from './CenteredContent.m.sass'

interface Props {
  className?: string
  children?: React.ReactNode
}

const CenteredContent = ({ className, children }: Props) => {
  return <div className={cx(styles.root, className)}>{children}</div>
}

export default CenteredContent
